import { render, staticRenderFns } from "./batas.vue?vue&type=template&id=72771f42&"
import script from "./batas.vue?vue&type=script&lang=js&"
export * from "./batas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports